/* istanbul ignore file */
import { generatePath } from '../utils'
import { getMpAgent } from './utils'

const mpAgent = getMpAgent()

const UPLOAD_PATH = '/collection/scratch/upload'
const UPLOAD_SINGLE_FIELD_PATH = '/fields/:resourceId/boundary'

export class UploadLandAPI {
  static upload(formData: FormData, uploadAsOneField?: 'true' | 'false') {
    const path = `${UPLOAD_PATH}?assignNewIds=true&oneFieldPerFile=${uploadAsOneField}`
    return mpAgent
      .put(path, formData, { timeout: 150 * 1000 })
      .then((response: any) => response?.data)
  }
  static uploadSingleField(formData: FormData, resourceId: string) {
    return mpAgent
      .put(generatePath(UPLOAD_SINGLE_FIELD_PATH, { resourceId }), formData, {
        timeout: 150 * 1000,
      })
      .then((response: any) => response?.data)
  }
}
